import { Utils } from "@/plugins/utils"
import router from "@/router"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstDa1: [],
		lstDa1NotInvoiced: [],
		da1: null,
		loading: false,
		notInvoiced: false,
		itemsPerPage: 20,
		search: "",
		cv5opercom: "",
		hasNext: false,
		hasNextInvoiced: false,
		hasNextNotInvoiced: false,
		since: moment().subtract(1, "months").format("YYYY-MM-DDT00:00"),
		until: moment().format("YYYY-MM-DDT23:59"),
		lstDa2: [],
		cf1: null,
		lstDa2Confirmed: [],
		lstDa3: [],
		lstMerged: [],
		viewMode: "Faturados",
	},

	getters: {
		da1model(state) {
			let da1 = state.da1 || { da1cancel: false }
			da1.lstDa2 = state.lstDa2Confirmed
			return da1
		},
		qtdeAmountConfirmed(state) {
			return state.lstDa2Confirmed.reduce((total, item) => total + (item.cv7totqtde || 0), 0)
		},
		groupedAmountConfirmed(state) {
			return state.lstDa2Confirmed.reduce((total, item) => total + (parseFloat(item.cv5totalnf) || 0), 0)
		},
		documentsAmountConfirmed(state) {
			return state.lstDa2Confirmed.length
		},
	},

	mutations: {
		initForm(state) {
			state.da1 = {
				da1cancel: true,
				da1cliente: "",
				da1inicio: moment().subtract(1, "months").format("YYYY-MM-DDT00:00"),
				da1fim: moment().format("YYYY-MM-DDT23:59"),
				da1status: "",
				da1desc: "",
				imported: false,
			}
			state.lstDa2 = []
			state.lstDa2Confirmed = []
		},
		updateTotals(state) {
			const docs = state.lstDa2Confirmed || []

			const totalItens = docs.reduce((sum, d) => sum + (parseFloat(d.cv7totqtde) || 0), 0)

			const totalDocs = docs.length

			const totalValor = docs.reduce((sum, d) => sum + (parseFloat(d.cv5totalnf) || 0), 0)

			if (!state.da1) state.da1 = {}
			state.da1.da1itens = totalItens
			state.da1.da1qtddoc = totalDocs
			state.da1.da1vldoc = totalValor
		},
		set(state, da1) {
			state.da1 = da1
			state.da1.da1docfis = da1.da1docfis ? da1.da1docfis.split(",").map(t => t.trim()) : []
			state.da1.da1grupo = da1.da1grupo ? da1.da1grupo.split(",").map(t => t.trim()) : []

			state.lstDa2 = da1.lstDa2 || []
		},
		setLstDa3(state, lstDa3) {
			state.lstda3 = lstDa3
		},
		setParamsDataTable(state, payload) {
			state.lstDa1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
			state.hasNextInvoiced = payload.hasNext
		},
		setDocuments(state, lstDa2) {
			state.lstDa2 = lstDa2
		},
		setParamsDataTableNotInvoicedDocuments(state, payload) {
			state.lstDa1NotInvoiced = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
			state.hasNextNotInvoiced = payload.hasNext
		},
		setMergedList(state, { items, limit, hasNext }) {
			state.lstMerged = items
			state.itemsPerPage = limit
			state.hasNext = hasNext
		},
	},

	actions: {
		initForm({ commit }) {
			commit("initForm")
		},

		normalizeDA1ForApi({ state }, da1) {
			const copy = da1

			if (Array.isArray(copy.da1docfis)) copy.da1docfis = copy.da1docfis.join(",")
			if (Array.isArray(copy.da1grupo)) copy.da1grupo = copy.da1grupo.join(",")

			if (Array.isArray(copy.da1enderid)) copy.da1enderid = copy.da1enderid.map(String)

			delete copy.issueDate
			delete copy.initDate
			delete copy.endDate

			return copy
		},

		async findGroupingDocuments({ state, dispatch }, { cancelledAndReturned = false }) {
			let da1inicio = state.da1.da1inicio
			let da1fim = state.da1.da1fim
			let da1docfis = state.da1.da1docfis
			let cv5opercom = state.cv5opercom

			if (!da1inicio) da1inicio = moment().subtract(1, "months").format("YYYY-MM-DDT00:00")
			if (!da1fim) da1fim = moment().format("YYYY-MM-DDT23:59")
			if (!da1docfis) da1docfis = ""
			if (!cv5opercom) cv5opercom = ""

			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Pesquisando Documentos...",
					indeterminate: true,
				},
				{ root: true },
			)
			let payload = await this._vm.$axios
				.get(
					`/FiscalDocument/GroupingDocuments/FindGroupingDocuments?da1cliente=${state.da1.da1cliente}&da1docfis=${da1docfis}&da1grupo=${state.da1.da1grupo}&da1enderid=${state.da1.da1enderid}&cancelledAndReturned=${cancelledAndReturned}&da1inicio=${da1inicio}&da1fim=${da1fim}&cv5opercom=${encodeURIComponent(cv5opercom)}`,
				)
				.then(response => {
					let lstDa2 = Utils.ValidateAxiosResponse(response.data)
					lstDa2.forEach(item => (item.selected = true))
					state.lstDa2 = lstDa2
					state.lstDa2Confirmed = lstDa2
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
			return payload
		},

		async save({ state, dispatch, getters }) {
			var text = getters.da1model.generate ? "Gerando agrupamento" : "Salvando agrupamento"
			if (getters.da1model.lstDa2.length > 150) text += ". Esse processo pode levar um tempo..."

			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: text,
					indeterminate: true,
				},
				{ root: true },
			)
			let editMode = !!state.da1.da1agrup

			if (!state.da1.da1inicio) state.da1.da1inicio = moment().subtract(1, "months").format("YYYY-MM-DDT00:00")

			if (!state.da1.da1fim) state.da1.da1fim = moment().format("YYYY-MM-DDT23:59")

			if (Array.isArray(state.da1.da1docfis)) this._vm.$set(state.da1, "da1docfis", state.da1.da1docfis.join(","))

			if (Array.isArray(state.da1.da1grupo)) this._vm.$set(state.da1, "da1grupo", state.da1.da1grupo.join(","))

			let payload
			try {
				const body = await dispatch("normalizeDA1ForApi", getters.da1model)
				const response = await this._vm.$axios.post("/FiscalDocument/GroupingDocuments/Save", {
					...body,
					edit: editMode,
				})

				let relatPath = Utils.ValidateAxiosResponse(response.data)
				// if (relatPath) dispatch("print/openRelatsPath", [relatPath], { root: true });

				router.push("/oryxpdv/agrupamentos-de-documentos")
				state.da1 = null
				state.lstDa2 = []

				state.lstDa2Confirmed = []
				payload = true
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				payload = false
			}

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
			return payload
		},
		async fetchAndMergeLists({ state, commit, dispatch }, { limit, page, orderBy, cancelledAndReturned, cfhGroups }) {
			state.loading = true

			const [result1, result2] = await Promise.all([
				dispatch("searchByNotInvoicedDocuments", { limit, page, orderBy, cancelledAndReturned, cfhGroups, suppressLoading: true }),
				dispatch("search", { limit, page, orderBy, cfhGroups, suppressLoading: true }),
			])

			if (result1 && result2) {
				const mergedItems = [...state.lstDa1, ...state.lstDa1NotInvoiced]
				commit("setMergedList", {
					items: mergedItems,
					limit: state.itemsPerPage,
					hasNext: state.hasNextInvoiced || state.hasNextNotInvoiced,
				})
			}
			state.loading = false
		},
		async cancel({ state, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Cancelando agrupamento",
					indeterminate: true,
				},
				{ root: true },
			)
			const body = await dispatch("normalizeDA1ForApi", getters.da1model)
			let payload = await this._vm.$axios
				.post("/FiscalDocument/GroupingDocuments/Cancel", { ...body })
				.then(response => {
					let relatPath = Utils.ValidateAxiosResponse(response.data)

					router.push("/oryxpdv/agrupamentos-de-documentos")
					state.da1 = null
					state.lstDa2 = []
					state.lstDa2Confirmed = []
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
			return payload
		},
		async edit({ state, dispatch, getters, commit }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Reabrindo agrupamento",
					indeterminate: true,
				},
				{ root: true },
			)
			if (Array.isArray(state.da1.da1docfis)) this._vm.$set(state.da1, "da1docfis", state.da1.da1docfis.join(","))

			if (Array.isArray(state.da1.da1grupo)) this._vm.$set(state.da1, "da1grupo", state.da1.da1grupo.join(","))

			const body = await dispatch("normalizeDA1ForApi", getters.da1model)
			let payload = await this._vm.$axios
				.post("/FiscalDocument/GroupingDocuments/Edit", { ...body })
				.then(da1 => {
					commit("set", da1)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
			return payload
		},
		async search(
			{ state, commit, dispatch },
			{ limit = 20, page = 1, orderBy = "DESC", cfhGroups = [], suppressLoading = false },
		) {
			state.loading = true
			commit("initForm")

			let url = `/FiscalDocument/GroupingDocuments/Search?search=${state.search}&limit=${limit}&page=${page}&orderBy=${orderBy}&cfhGroups=${cfhGroups}`
			if (state.since) url += `&since=${state.since}`
			if (state.until) url += `&until=${state.until}`
			if (state.cv5opercom && state.cv5opercom != "") {
				url += `&cv5opercom=${encodeURIComponent(state.cv5opercom)}`
			}

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					state.lstDa1 = []
					state.hasNext = false
					state.hasNextInvoiced = false
					state.search = ""
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})

			if (!suppressLoading) state.loading = false
			return payload
		},
		async searchByNotInvoicedDocuments(
			{ state, commit, dispatch },
			{ limit = 20, page = 1, orderBy = "DESC", cancelledAndReturned = false, cfhGroups = [], suppressLoading = false },
		) {
			state.loading = true
			commit("initForm")

			let url = `/FiscalDocument/GroupingDocuments/SearchByNotInvoicedDocuments?search=${state.search}&limit=${limit}&page=${page}&orderBy=${orderBy}&cancelledAndReturned=${cancelledAndReturned}&cfhGroups=${cfhGroups}`
			if (state.since) url += `&since=${state.since}`
			if (state.until) url += `&until=${state.until}`
			if (state.cv5opercom && state.cv5opercom != "") {
				url += `&cv5opercom=${encodeURIComponent(state.cv5opercom)}`
			}

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTableNotInvoicedDocuments", payload)
					return true
				})
				.catch(error => {
					state.lstDa1NotInvoiced = []
					state.hasNext = false
					state.hasNextNotInvoiced = false
					state.search = ""
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})

			if (!suppressLoading) state.loading = false
			return payload
		},
		async find({ state, commit, dispatch }, { da1agrup, edit, search, cancelledAndReturned = false }) {
			let da1inicio = state.da1.da1inicio
			let da1fim = state.da1.da1fim
			let da1docfis = state.da1.da1docfis || []
			let da1enderid = state.da1.da1enderid || []
			let cv5opercom = state.cv5opercom
			let boolsearch = search || false

			if (!da1inicio) da1inicio = moment().subtract(1, "months").format("YYYY-MM-DDT00:00")
			if (!da1fim) da1fim = moment().format("YYYY-MM-DDT23:59")
			if (!cv5opercom) cv5opercom = ""

			if (
				da1inicio == moment().subtract(1, "months").format("YYYY-MM-DDT00:00") &&
				da1fim == moment().format("YYYY-MM-DDT23:59") &&
				edit == true
			) {
				await this._vm.$axios.get(`/FiscalDocument/GroupingDocuments/FindInterval/${da1agrup}`).then(response => {
					let interval = Utils.ValidateAxiosResponse(response.data)
					da1inicio = interval.da1inicio
					da1fim = interval.da1fim
				})
			}

			let url = `/FiscalDocument/GroupingDocuments/Find/?da1agrup=${da1agrup}&edit=${edit}&da1inicio=${da1inicio}&da1fim=${da1fim}&boolsearch=${boolsearch}&cancelledAndReturned=${cancelledAndReturned}`

			if (Array.isArray(da1docfis) && da1docfis.length > 0) url += `&da1docfis=${da1docfis}`

			if (Array.isArray(da1enderid) && da1enderid.length > 0) url += `&da1enderid=${da1enderid}`

			if (cv5opercom && cv5opercom != "") url += `&cv5opercom=${encodeURIComponent(cv5opercom)}`

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let da1 = Utils.ValidateAxiosResponse(response.data)
					if (edit && state.da1.da1agrup) {
						commit("setDocuments", da1.lstDa2 || [])
					} else {
						commit("set", da1)
					}
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async findItemsByDocuments({ commit, state, dispatch }) {
			let payload = await this._vm.$axios
				.post(
					`/FiscalDocument/GroupingDocuments/findItemsByDocuments`,
					JSON.parse(JSON.stringify(state.lstDa2Confirmed)),
				)
				.then(response => {
					let lstda3 = Utils.ValidateAxiosResponse(response.data)
					commit("setLstDa3", lstda3)
					return lstda3
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async printDocumentFiscal(store, { cv5doc, cv5tipo, cv5emissor, download = false }) {
			let cv5 = {
				cv5doc: cv5doc,
				cv5tipo: cv5tipo,
				cv5emissor: cv5emissor,
			}
			store.dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: `${download ? "Baixando documentos" : "Imprimindo documentos"}`,
					indeterminate: true,
				},
				{ root: true },
			)
			await this._vm.$axios
				.post("/FiscalDocument/GroupingDocuments/PrintDocumentFiscal", cv5)
				.then(response => {
					let relatsPath = Utils.ValidateAxiosResponse(response.data)
					if (relatsPath && relatsPath.length > 0) {
						if (download) store.dispatch("print/downloadFile", [relatsPath], { root: true })
						else store.dispatch("print/openRelatsPath", [relatsPath], { root: true })
					}
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return true
		},
		async printReportProductShipment(store, da1agrup ){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo Agrupamento de Documentos", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.get("/FiscalDocument/GroupingDocuments/PrintReportProductShipment/"+ da1agrup)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

                if(relatPath)
                    store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		}
	},
}
